import { ClarityLogo } from '@/components/ClarityLogo';
import { LANDING_DESCRIPTION, LANDING_TITLE } from '@/utils/messages';
import { CircularProgress, Typography } from '@mui/material';
import { Landing } from '@verifime/components';
import { useTokens } from '@verifime/cognito-passwordless-auth';
import tokens from '@verifime/design-tokens';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { runMintEffect } from '@/effects/mintEffect';

export const SIGN_UP_CODE_MINT_PATH = '/sign-up-code/mint';

/**
 * Intermediary page that silently converts a sign-up code into a tracking
 * reference via the invite API. The customer never sees a form here; they
 * are redirected immediately after the API call completes.
 *
 * Guard: if no sign-up code is in storage (e.g. the user navigated here
 * directly) we fall back to the generic sign-up entry.
 */
export default function MintFromSignUpCode() {
  const router = useRouter();
  const { getTokensParsed } = useTokens();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    void runMintEffect({ push: router.push, getTokensParsed });
  }, [router.push, getTokensParsed]);

  return (
    <Landing
      title={LANDING_TITLE}
      description={LANDING_DESCRIPTION}
      logo={<ClarityLogo colorMode="onPrimary" />}
    >
      <CircularProgress color="inherit" size={tokens.fontSizeBase} />
      <Typography variant="body1">Please wait</Typography>
    </Landing>
  );
}
